const performIntroduceRourer = {
  path: '',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: '/perform_introduce',
      name: 'PerformIntroduce',
      meta: { title: '平台介绍' },
      component: () => import(/* webpackChunkName: "privacy" */ '@/pages/platform')
    }
  ]
}

export default performIntroduceRourer
